<template>
  <div v-if="allPermission">
    <div v-for="(module, index) in filteredPermissions" :key="index">
      <div class="pd-20px checkbox-custom-disabled">
        <b-checkbox v-model="module.selected" :type="isDisabled" :disabled="disable"
                    @input="switchAllValueSelected(module, module.selected)">
          <div class="columns is-vcentered">
            <div class="column is-narrow">
              <img :src=module.image class="mgl-10px iconMenu">
            </div>
            <span class="is-link has-text-weight-bold is-size-6 column is-paddingless">
            {{$t('roleManager.modules.' + module.name)}}
          </span>
          </div>
        </b-checkbox>
        <div class="columns is-multiline mgt-5px">
          <div class="column is-2" v-for="(categorie, index) in module.categorie" :key="index">
            <div v-if="isDisplayable('roleManager.categories.' + categorie.name)">
              <span class="is-link has-text-weight-bold is-size-6">
                {{$t('roleManager.categories.' + categorie.name)}}
              </span>
              <div v-for="(droit, index) in categorie.droit" :key="index">
                <b-checkbox v-if="isDisplayable('roleManager.droits.' + droit.nameDroit)"
                          v-model="droit.selected"
                          :disabled="disable"
                          :type="isDisabled"
                          class="mgt-10px"
                          @input="activeModule(module)">
                  {{$t('roleManager.droits.' + droit.nameDroit)}}
                </b-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr v-if="index !== filteredPermissions.length - 1" class="is-marginless"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'roleManager',
  props: {
    allPermission: {
      type: Array,
      required: true,
    },
    disable: {
      type: Boolean,
      required: false,
    },
  },
  methods: {
    switchAllValueSelected(module, state) {
      module.categorie.forEach((categorie) => {
        categorie.droit.forEach((droit) => {
          droit.selected = state;
        });
      });
    },
    activeModule(module) {
      module.selected = false;
      module.categorie.forEach((categorie) => {
        categorie.droit.forEach((droit) => {
          if (droit.selected) {
            module.selected = true;
          }
        });
      });
    },
    isTranslate(sentence) {
      return this.$t(sentence) !== sentence;
    },
    isDisplayable(sentence) {
      return this.isUserSupport || this.isTranslate(sentence);
    },
  },
  computed: {
    isDisabled() {
      if (this.disable) {
        return 'is-default';
      }
      return 'is-primary';
    },
    isUserSupport() {
      return this.$store.getters['user/isSupport'];
    },
    filteredPermissions() {
      return this.allPermission.filter(module => this.isDisplayable('roleManager.modules.' + module.name));
    },
  },
};
</script>

<style scoped>
</style>
